import { AxiosResponse } from "axios";
import axiosInstance from "../../api";
import suggestiveInputHelpers from "../helpers/suggestiveInputHelpers";

function SuffixSideEffect(
 token: string,
 testType: string,
 setSuggestions: (response: AxiosResponse) => any
) {
 axiosInstance.get(`v1/suffixes`).then((response) => {
  if (response.data.data) {
   setSuggestions(
    response.data.data
     .sort((a: any, b: any) =>
      suggestiveInputHelpers.sortByAlphabeticalOrder(a, b, "name")
     )
     .map((item: any) => ({
      label: `${item.name}`,
      value: item.name,
     }))
   );
  }
 });
}

export default SuffixSideEffect;
